import { routes } from '@pmai/contracts';
import type { SelectOption } from '@pmai/ui';
import { useApiQuery } from '../../shared/api/hooks';

/** Every customer as select options, A→Z (project form, support form and filter). */
export function useCustomerOptions(enabled = true): SelectOption[] {
  const customers = useApiQuery(routes.customers.options, {}, { enabled });
  return (customers.data ?? []).map((c) => ({ value: c.id, label: c.name }));
}
